import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-square-button',
  template: `
    <app-base-button
      [baseClass]="'w-full h-20 bg-theme-surface2-50 p-1 rounded-lg flex items-center justify-between border border-theme-surface2'"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
    >
      <div class="flex justify-center w-full text-theme-text">
        <div class="flex flex-col items-center">
          <i class="fas text-lg mr-2" [class]="icon"></i>
          <div class="text-center   font-bold tabular-nums">{{ text }}</div>
        </div>
      </div>
    </app-base-button>
  `
})
export class SquareButtonComponent {
  @Input() text: string = 'Action';
  @Input() icon: string = 'fa-chevron-circle-right';
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
